import React from 'react';
import { components as reactSelectComponents } from 'react-select';

const renderPlaceholder = (Component = React.Fragment) => {
  const PlaceholderComponent = (placeholderProps) => {
    const { children, ...restProps } = placeholderProps;
    return (
      <reactSelectComponents.Placeholder {...restProps}>
        <Component>{children}</Component>
      </reactSelectComponents.Placeholder>
    );
  };

  PlaceholderComponent.displayName = 'PlaceholderComponent';

  return PlaceholderComponent;
};

export default renderPlaceholder;
